import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from "axios";
import Header from './Header';
import HeroBanner from './HeroBanner';
import PopularDestinations from './PopularDestinations';
import DealsSection from './TopDeals';
import CounterSection from './CounterSection';
import TrendingContainer from './TrendingContainer';
import AppPromoSection from './AppPromoSection';
import FaqContainer from './FaqContainer';
import Footer from './Footer';
import PageMeta from './PageMeta';
import JsonLd from './JsonLd';
import API_BASE_URL from "../../src/config";
import { ClipLoader } from "react-spinners";

// SearchAction/sitelinks-search-box deliberately omitted — /stays only
// reads search state passed via React Router's location.state, not a URL
// query param, so a direct URL like /stays?search=... wouldn't actually
// filter anything yet. Adding that hint without the underlying support
// would advertise a broken feature.
const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "GuestLinkup",
  url: "https://www.guestlinkup.com/",
  logo: "https://www.guestlinkup.com/images/logo.png",
  description: "GuestLinkup connects travelers with authentic family-run homestays in Northeast India.",
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "GuestLinkup",
  url: "https://www.guestlinkup.com/",
};

const Home = () => {
  const [data, setData] = useState(null);   // store API response
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-out-cubic',
      once: false,
    });

    //. Fetch API data once
    // const fetchData = async () => {
    //   try {
    //     const res = await fetch('https://demo.wgi-it.com:3002/api/v1/home'); 
    //   //  const res = await fetch(`${API_BASE_URL}home`);
    //     console.log(res)
    //     const json = await res.json();
    //     setData(json);
    //   } catch (err) {
    //     console.error("Error fetching data:", err);
    //     setError("Failed to load data");
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}home`);
        console.log(res);
        setData(res.data); // axios auto-parses JSON
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <ClipLoader size={45} />
      </div>
    );
  }


  if (error) return <p>{error}</p>;

  return (
    <>
      <PageMeta
        title="GuestLinkup - Himalayan Homestays"
        description="GuestLinkup connects travelers with authentic family-run homestays in Northeast India."
      />
      <JsonLd id="organization" schema={organizationSchema} />
      <JsonLd id="website" schema={websiteSchema} />
      <Header />
      <HeroBanner bannerData={data.data.banners} featuredPromos={data.data.featured_promos} />
      <PopularDestinations destinations={data.data.popular_destinations} />
      <DealsSection deals={data.data.top_homestays} />
      <CounterSection stats={data.data.stats} />
      <TrendingContainer trending={data.data.trending} />
      <AppPromoSection promo={data.promo} />
      <FaqContainer faqs={data.faqs} />
      <Footer footerData={data.footer} />
    </>
  );
};

export default Home;
